import React from 'react';
import Header from './Header';
import Navbar from './Navbar';
import Footer from './Footer';
import { ThemeProvider } from '../Layout/Theme/ThemeContext'; 
import { SidebarProvider } from './SidebarContext'; // Import SidebarProvider

function Layout({ children }) {
  return (
    <ThemeProvider>
      
      <div class="main-content d-flex flex-column">
          <Header />
         
          {children}
        </div>
       
      
    </ThemeProvider>
  );
}

export default Layout;
